import type { HTMLAttributes } from 'react';
import styles from './EditableField.module.css';

export interface EditableFieldProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Label for the field
   */
  label: string;
  /**
   * Current value to display
   */
  value: string;
  /**
   * Callback when edit link is clicked
   */
  onEdit?: () => void;
  /**
   * Whether the edit link should be shown
   * @default true
   */
  showEdit?: boolean;
}

export function EditableField({
  label,
  value,
  onEdit,
  showEdit = true,
  className,
  ...props
}: EditableFieldProps) {
  const containerClasses = [
    styles.container,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses} {...props}>
      <label className={styles.label}>{label}</label>
      <div className={styles.valueRow}>
        <span className={styles.value}>{value}</span>
        {showEdit && onEdit && (
          <button
            type="button"
            onClick={onEdit}
            className={styles.editLink}
          >
            Editar
          </button>
        )}
      </div>
    </div>
  );
}

EditableField.displayName = 'EditableField';
